<template>
   <div class="">
    <router-link :to="$route.name == 'branch_invoice' ? { name:'branch_invoice_details', query: $route.query.branchId ? { id: data.id, branchId: $route.query.branchId, companyId: $route.query.companyId } : { id: data.id, companyId: $route.query.companyId }} : { name:'invoice_details', query: {id: data.id, companyId: $route.query.companyId }}" class="mr-3 btn details_btn">
      {{ $t('text.clickButtons.view') }}
    </router-link>
    
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    downloadPdf(id) {
      this.axios({
        url: `${configObject.apiBaseUrl}/Invoices/${this.data.id}/receipt-to-pdf`,
        method: 'GET',
        headers: configObject.authConfig().headers,
        responseType: 'blob',
      }).then((response) => {
          let disposition = response.headers["content-disposition"];
          let depositionArr = disposition.split(";")[1]

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', depositionArr.split("=")[1].split("_").join("_").replace(/["']/g, ""));
          document.body.appendChild(fileLink);

          fileLink.click();
         this.$store.commit("setShowLineLoader", false)
          this.$toast("Download Successful", {
              type: "success",
              timeout: 3000
          });
          this.isButtonDisabled = false;
            
      }).catch(e => {
       
        
      })
    },
  }
};

</script>